import { gql } from '@apollo/client';

export const GET_STYLISTS = gql`
  query GetStylists {
    stylists {
      id
      user {
        id
        firstName
        lastName
        gender
        birthDate
        profilePicUrl
        address {
          city
        }
      }
      expertise
      aesthetics
      pricing {
        id
        hourlyRate
        tierName
      }
      customHourlyRate
      hasCompletedStripeSetup
      isEventAttendee
      isFavorited
      computedInPersonAvailability
      isAvailableInPerson
      customInPersonHourlyRate
    }
  }
`;

export const GET_STYLIST = gql`
  query GetStylist($input: GetStylistInput!) {
    stylist(input: $input) {
      id
      userId
      expertise
      aesthetics
      instagram
      tiktok
      substack
      bio
      landscapeImage
      portraitImages
      user {
        firstName
        lastName
        gender
        birthDate
        profilePicUrl
      }
      pricing {
        id
        hourlyRate
        tierName
      }
      customHourlyRate
      customInPersonHourlyRate
      computedInPersonAvailability
      hasCompletedStripeSetup
      isEventAttendee
      isFavorited
    }
  }
`;

export const GET_STYLIST_SCHEDULING_DATA = gql`
  query SchedulingData {
    schedulingData {
      stylistId
      nylasConnections {
        id
        email
        provider
        grantId
      }
      scheduleConfigs {
        config
        nylasConfigId
        id
        eventType
        timezone
        bookingCalendarId
        availabilityCalendarIds
      }
      calendars {
        name
        id
        calendarId
        isOwnedByUser
      }
      openHours {
        day
        startTime
        endTime
      }
      availabilitySlots {
        id
        date
        startTime
        endTime
      }
    }
  }
`;

export const GET_STYLIST_NEXT_AVAILABLE_SLOT = gql`
  query NextAvailableSlot($input: NextAvailableSlotInput!) {
    nextAvailableSlot(input: $input) {
      startTime
      eventType
    }
  }
`;

export const GET_STYLIST_SHARE_PROFILE_URL = gql`
  query StylistShareProfileUrl($input: GetStylistShareProfileUrlInput!) {
    stylistShareProfileUrl(input: $input) {
      shareProfileUrl
    }
  }
`;

export const GET_STYLIST_ID_BY_SHARE_CODE = gql`
  query GetStylistIdByShareCode($input: GetStylistByShareCodeInput!) {
    getStylistIdByShareCode(input: $input) {
      stylistId
    }
  }
`;
